import { SymbolsAnimationFactory } from './SymbolsAnimationFactory'
import { SymbolContainerData } from '@/modules'

export class MultiplierSymbolsFactory extends SymbolsAnimationFactory {
    private static readonly AVAILABLE_MULTIPLIERS: number[] = [2, 3, 4, 5, 6, 8, 10, 15, 20, 25, 50, 100]

    public getAnimationResource(): string {
        return 'MULTIPLIER'
    }

    public getAnimationLabel(symbolData: SymbolContainerData, state: string): string {
        const baseLabel = MultiplierSymbolsFactory.ANIMATIONS[state]
        if (!baseLabel) {
            return null
        }

        const rawMultiplier = symbolData?.multiplier ?? 2
        const multiplier = MultiplierSymbolsFactory.AVAILABLE_MULTIPLIERS.includes(rawMultiplier) ? rawMultiplier : 2
        return `x${multiplier}`
    }

    public static readonly ANIMATIONS: Record<string, string> = {
        ['land']: 'x',
        ['win']: 'x',
        ['trigger']: 'x',
    }
}
